/* eslint-disable no-magic-numbers */
import { TPartialCoefficientsReportItem } from '@/pages/supplies-management/children/warehouses-limits/page/_components/connected-warehouses-limits/_components/warehouses-limits-view/_components/limits-table/types';
import { WAREHOUSES_LIMITS_UP_TO_DAY } from '@/pages/supplies-management/children/warehouses-limits/page/_components/connected-warehouses-limits/_constants';
import { TSearchMultiInputOptionsArray } from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';

type TProps = {
  selectedDate: Date | null;
  selectedWarehouses: TSearchMultiInputOptionsArray | null;
};

const initialValueForWarehouses = Array(1).fill(0);

export const getDummyCoefficients = ({
  selectedDate,
  selectedWarehouses = initialValueForWarehouses,
}: TProps): TPartialCoefficientsReportItem => {
  const date = selectedDate || new Date(Date.now() + 3600 * 1000 * 24);

  const dummyDataItem = [...Array(WAREHOUSES_LIMITS_UP_TO_DAY)].map(
    (el, index) => ({
      date: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + index,
      ).toISOString(),
      coefficient: -1,
    }),
  );

  return selectedWarehouses.map(() => ({
    boxes: dummyDataItem,
    palette: dummyDataItem,
    superSafe: dummyDataItem,
  }));
};
